if (!customElements.get("bed-builder-option")) {
  customElements.define(
    "bed-builder-option",
    class ProductBedBuilderOption extends HTMLElement {
      constructor() {
        super();

        this.index = this.dataset.index;
        this.calculatePrice =
          (this.dataset.priceNoCalculate || false) == "true" ? false : true;

        this.optionLabels = this.querySelectorAll("label .option-title");
        this.options = this.querySelectorAll('input[type="radio"]');
        this.addonOptions = this.querySelectorAll('input[type="checkbox"]');
        this.selectedOption = false;
        this.selectedVariants = [];
        this.filterOptions = {};
        this.getProductData();

        this.parent = {
          formatMoney: (cents) => {
            if (cents && !isNaN(cents)) {
              let amount = (cents / 100.0).toFixed(2);
              let parts = amount.split(".");
              amount =
                parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + ",") +
                (parts[1] ? "." + parts[1] : "");
              return `\$${amount}`;
            }
            return false;
          },
        };
      }

      connectedCallback() {
        if (this.isConnected) {
          this.attachEvents();
          Array.from(this.options)
            .filter((opt) => opt.checked)
            .forEach((opt) => opt.dispatchEvent(new Event("change")));
          if (this.closest("product-bed-builder")) {
            this.parent = this.closest("product-bed-builder");
          }
        }
      }

      attachEvents() {
        this.options.forEach((opt) =>
          opt.addEventListener("change", this.onOptionChange.bind(this))
        );
        this.addonOptions.forEach((opt) =>
          opt.addEventListener("change", this.onAddonOptionChange.bind(this))
        );
        ["close", "back", "next"].forEach((evt) =>
          this.addEventListener(evt, this.onModalEvent.bind(this))
        );
      }

      onOptionChange(evt) {
        evt.stopPropagation();
        const target = evt.target;
        this.selectedOption = target.value;
        this.options.forEach((opt) => {
          opt.checked = opt.value == this.selectedOption;
        });
        this.addonOptions.forEach((opt) => {
          if (opt.dataset.requires == this.selectedOption) {
            opt.removeAttribute("disabled");
          } else {
            opt.setAttribute("disabled", "disabled");
            opt.checked = false;
          }
        });
        this.updateSelected();
        this.dispatchEvent(
          new CustomEvent("change", {
            bubbles: true,
            detail: { selected: this.selectedVariants },
          })
        );
      }

      onAddonOptionChange(evt) {
        evt.stopPropagation();
        const target = evt.target;

        if (this.selectedOption != target.dataset.requires) {
          target.checked = false;
          return;
        }

        this.updateSelected();
        this.dispatchEvent(
          new CustomEvent("change", {
            bubbles: true,
            detail: { selected: this.selectedVariants },
          })
        );
      }

      onModalEvent(evt) {
        evt.stopPropagation();
        this.dispatchEvent(
          new CustomEvent(`modal:${evt.type}`, {
            bubbles: true,
            cancelable: true,
            detail: {
              index: this.index,
              name: this.name,
            },
          })
        );
      }

      openModal(target) {
        const modal = this.querySelector("option-select-modal");
        if (modal) modal.show(target);
      }

      setOptions(options) {
        this.filterOptions = { ...this.filterOptions, ...options };
        this.updateSelected();

        return this.selectedVariants;
      }

      updateSelected() {
        this.getProductData();
        if (!this.productData) {
          return;
        }

        let currentProduct = this.productData.filter(
          (item) => item.id == this.selectedOption
        )[0];
        if (currentProduct && this.filterOptions) {
          this.selectedVariants = this.findMatchingVariant(
            currentProduct,
            this.filterOptions
          );
        } else {
          this.selectedVariants = [];
        }
        let currentAddons = Array.from(this.addonOptions).filter(
          (opt) => opt.checked
        );
        if (currentAddons.length) {
          currentAddons.forEach((addon) => {
            this.selectedVariants.push({
              id: addon.value,
              price: addon.dataset.price * 1 || 0,
              available: addon.dataset.available || true,
            });
          });
        }
        if (!this.calculatePrice) {
          this.selectedVariants.forEach((variant) => {
            variant.price = 0;
          });
        }
        this.updateDisplay();
      }

      findMatchingVariant(product, filterOptions) {
        let possibleMatches = [...product.variants];
        Object.keys(filterOptions).forEach((key) => {
          possibleMatches = possibleMatches.filter((item) => {
            return (
              (Object.keys(item.options).includes(key) &&
                item.options[key] == filterOptions[key]) ||
              (Object.keys(item.options).includes(key) &&
                item.options[key].constructor == Array &&
                item.options[key].includes(filterOptions[key])) ||
              !Object.keys(item.options).includes(key) ||
              item.options === false
            );
          });
        });
        return possibleMatches;
      }

      updateDisplay() {
        if (this.optionLabels.length) {
          this.optionLabels.forEach(
            (label) => (label.innerText = this.filterOptions.Size)
          );
        }

        // const displayPrices = this.findMatchingVariant(
        //   this.productData[0],
        //   this.filterOptions
        // )[0];
        // if (displayPrices.discount) {
        //   this.parent.discount = displayPrices.discount;
        // }

        //this.formatMoney(price)
        // if (displayPrices.discount) {
        //   console.log(this.parent.formatMoney(regPrice),this.parent.formatMoney(newPrice), this.parent.formatMoney(displayPrices.price), this.parent.formatMoney(displayPrices.discount));
        // }
        // if (prices.length && displayPrices) {
        //   let newPrice = displayPrices.original_price || displayPrices.price;
        //   this.querySelectorAll('.product-bed-builder__cost--original span').forEach(spot => spot.innerText = this.parent.formatMoney(newPrice));
        //   if (displayPrices.discount) {
        //     prices.forEach(price => price.classList.add('product-bed-builder__cost--discount'));
        //     this.querySelectorAll('.product-bed-builder__cost--combo').forEach(combo => {
        //       combo.querySelector('span').innerText = this.parent.formatMoney(displayPrices.price);
        //       combo.classList.remove('hidden');
        //     });
        //     this.querySelectorAll('.product-bed-builder__cost--savings').forEach(combo => {
        //       combo.querySelector('span').innerText = this.parent.formatMoney(displayPrices.discount);
        //       combo.classList.remove('hidden');
        //     });
        //   } else {
        //     prices.forEach(price => price.classList.remove('product-bed-builder__cost--discount'));
        //     this.querySelectorAll('.product-bed-builder__cost--combo').forEach(combo => combo.classList.add('hidden') );
        //     this.querySelectorAll('.product-bed-builder__cost--savings').forEach(combo => combo.classList.add('hidden') );
        //   }
        // }
      }

      getSelectedLabel() {
        if (this.productData && this.selectedOption) {
          const theProduct = this.productData.filter(
            (prod) => prod.id == this.selectedOption
          )[0];
          if (theProduct) {
            return theProduct.label;
          }
        }
      }

      getProductData() {
        if (this.productData) {
          return this.productData;
        }
        let data = this.querySelector(
          'script[type="application/json"][data-type="settings"]'
        );
        if (data) {
          try {
            this.productData = JSON.parse(data.textContent || "[]");
          } catch (error) {
            console.error(`Unable to parse JSON product json:`, error, data);
          }
        }
      }
    }
  );
}

if (!customElements.get("product-bed-builder")) {
  customElements.define(
    "product-bed-builder",
    class ProductBedBuilder extends HTMLElement {
      static get observedAttributes() {
        return ["options", "variant"];
      }

      constructor() {
        super();

        this.sectionId = this.dataset.section;
        this.baseVariant = {};
        this.pdpPrice = document.querySelector(`#price-${this.sectionId}`);
        this.pdpForm = document.querySelector("product-form");
        this.variantSelects = document.querySelectorAll(
          "variant-selects, variant-radios"
        );
        this.colorSelect = document.querySelector(
          'select[name="options[Color]"]'
        );
        this.builderOptions = this.querySelectorAll("bed-builder-option");

        this.modalEvents = ["modal:close", "modal:back", "modal:next"];
        this.isAddingToCart = false;
        this.sections = {};
        this.bedOptionValues = {};
        this.bedData = {};
        this.getOptionData();

        if (this.colorSelect.length) {
          let currentColor = this.colorSelect.value.toLowerCase();
          let colorSwatch = this.colorSelect.previousElementSibling;
          colorSwatch.dataset.current = currentColor;
        }
      }

      connectedCallback() {
        if (this.isConnected) {
          this.getOptionData();
          this.attachEvents();
        }
      }

      attachEvents() {
        this.pdpForm.useCartEvent = true;
        this.pdpForm.addEventListener(
          "product:add-to-cart",
          this.onFormSubmit.bind(this)
        );
        this.variantSelects.forEach((select) =>
          select.addEventListener(
            "variant:change",
            this.onVariantUpdate.bind(this)
          )
        );
        this.colorSelect.addEventListener(
          "change",
          this.onColorUpdate.bind(this)
        );
        this.builderOptions.forEach((section) =>
          section.addEventListener("change", this.onSelectionChange.bind(this))
        );
        this.modalEvents.forEach((evt) =>
          this.addEventListener(evt, this.onModalEvent.bind(this))
        );
      }

      onColorUpdate(evt) {
        const colorSwatch = evt.target.previousElementSibling;
        if (colorSwatch) {
          colorSwatch.dataset.current = evt.target.value.toLowerCase();
        }
      }

      onVariantUpdate(evt) {
        // get value of first select
        const variant = evt.detail.variant.option1;

        // get bed builder with data-name="mattress"
        const mattress = this.querySelector(
          `bed-builder-option[data-name="mattress"] select`
        );
        // get selected mattress data-variants
        if (mattress.options[mattress.selectedIndex].dataset.variants) {
          const mattressVariants =
            mattress.options[mattress.selectedIndex].dataset.variants.split(",");
          // if variant is not in mattress variants, reset mattress to first option
          if (!mattressVariants.includes(variant)) {
            mattress.selectedIndex = 0;
            mattress.dispatchEvent(new Event("change"));
          }
        }

        if (evt.detail && evt.detail.variant) {
          this.setAttribute("variant", evt.detail.variant.id);
          this.setAttribute(
            "options",
            JSON.stringify(evt.detail.variant.options)
          );
        }
      }

      onSelectionChange(evt) {
        if (evt.target.classList.contains("faux-select")) {
          const optionRadio = evt.target
            .closest("bed-builder-option")
            .querySelector(`[data-product="${evt.target.value}"]`)
            .querySelector("input");
          optionRadio.checked = true;
          optionRadio.dispatchEvent(new Event("change"));

          // if select is inside a option-select-modal, hide all options and show selected option
          if(evt.target.closest("option-select-modal")) {
            // change all selects to match value
            const selects = document.querySelectorAll(".product-options-modal__option.mattress select");
            selects.forEach((select) => {
              select.value = evt.target.value;
            });
            evt.target.closest(".product-options-modal__option").classList.add("hidden");
            // get value of select
            const selectedValue = evt.target.value;
            // get option-select-modal that contains a radio input with value of select
            const modalOption = document.querySelector(
              `.product-options-modal__option input[value="${selectedValue}"]`
            ).closest(".product-options-modal__option");
            // hide all other options
            const modalOptions = document.querySelectorAll(".product-options-modal__option.mattress");
            modalOptions.forEach((option) => {
              if(option !== modalOption) {
                option.classList.add("hidden");
              }
            });
            // remove hidden class from selected modalOption
            modalOption.classList.remove("hidden");
          }
          
        } else {
          const target = evt.target;
          const data = evt.detail.selected || false;
          this.sections[target.index] = data;

          // get current event target select
          const targetValue = target.querySelector("select");
          // if target value has data-variants, get the variants
          if (targetValue.options[targetValue.selectedIndex].dataset.variants) {
            const availableSizes =
              targetValue.options[
                targetValue.selectedIndex
              ].dataset.variants.split(",");
            // if available sizes is missing a size, disable it
            const sizeSelect = document.querySelector(
              'select[name="options[Size]"]'
            );
            for (let i = 0; i < sizeSelect.options.length; i++) {
              const option = sizeSelect.options[i];
              if (availableSizes.indexOf(option.value) == -1) {
                option.disabled = true;
              } else {
                option.disabled = false;
              }
            }
            // if current size is disabled
            if (
              sizeSelect.options[sizeSelect.selectedIndex].disabled &&
              availableSizes.length
            ) {
              // get first option that is not disabled
              const firstAvailableSize = sizeSelect.querySelector(
                `option:not([disabled])`
              );
              // set size to first available size
              sizeSelect.value = firstAvailableSize.value;
            }
            
          } else {
            // enable all sizes
            const sizeSelect = document.querySelector(
              'select[name="options[Size]"]'
            );
            for (let i = 0; i < sizeSelect.options.length; i++) {
              const option = sizeSelect.options[i];
              option.disabled = false;
            }
          }

          // if current selection is a mattress, update faux-select
          if (targetValue.options.selectedIndex !== 0 && evt.target.querySelector("option-select-modal").hasAttribute("open")) {
            this.updatePrice(data);
          } else if(!evt.target.querySelector("option-select-modal").hasAttribute("open")){
            this.updatePrice(data);
          }

          // if modal is open update faux select in option
          if (
            evt.target.querySelector("option-select-modal").hasAttribute("open")
          ) {
            const fauxSelect = evt.target.querySelector(".faux-select");
            if (fauxSelect) {
              fauxSelect.value = evt.target.querySelector(
                "option-select-modal input:checked"
              ).value;
              fauxSelect.dispatchEvent(new Event("change"));
            }
          }
        }

        // update modal select options
        this.querySelectorAll(".product-options-modal__option select").forEach((select) => {
          // get faux-select under bed-builder-option with data-name="mattress"
          const mattressSelection = document.querySelector(
            `bed-builder-option[data-name="mattress"] .faux-select`
          ).value;

          // for each select in mattress option, set value to faux-select value
          this.querySelectorAll(".product-options-modal__option.mattress select").forEach((select) => {
            // if select doesn't have option with value of mattressSelection, set value to first option
            if(!select.querySelector(`option[value="${mattressSelection}"]`)) {
              select.value = select.querySelector("option").value;
            } else {
              select.value = mattressSelection;
            }
          });

        });
        // update modal option visibility
        this.querySelectorAll(".product-options-modal__option.mattress").forEach((option) => {
          if(option.querySelector("input[name='modal[mattress]']:checked")) {
            option.classList.remove("hidden");
          } else {
            option.classList.add("hidden");
          }
        });
        // if input with classname ".base" is checked, show first mattress option
        if(this.querySelector(".product-options-modal__option input.base:checked")) {
          this.querySelector(".product-options-modal__option.mattress").classList.remove("hidden");
        }
      }

      onFormSubmit(evt) {
        evt.stopPropagation();
        this.launchConfirm(evt.target.querySelector("button"));
      }

      onModalEvent(evt) {
        const target = evt.target;
        const next =
          target.nextSibling &&
          target.nextSibling.nodeName == "BED-BUILDER-OPTION"
            ? target.nextSibling
            : false;
        const prev = target.previousSibling || false;

        if (evt.type === "modal:close" && this.isAddingToCart) {
          this.abortAddToCart();
        } else if (evt.type === "modal:next" && next !== false) {
          next.openModal(target);
        } else if (evt.type === "modal:next") {
          this.addToCart(true);
        } else if (evt.type === "modal:back" && prev !== false) {
          prev.openModal(target);
        }
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (name === "options") {
          if (newValue != oldValue) {
            let parsedData = JSON.parse(newValue || "[]");
            if (this.bedData.options && parsedData) {
              this.bedData.options.forEach((option) => {
                this.bedOptionValues[option.name] =
                  parsedData[option.position - 1] || false;
              });
            }
            this.updateSelections();
            this.updatePrice();
          }
        } else if (name === "variant") {
          let items = this.bedData.available.filter(
            (item) => item.id == newValue
          );
          if (items.length) {
            this.baseVariant = items[0];
          }
        }
      }

      updateSelections() {
        this.builderOptions.forEach((builder) => {
          this.sections[builder.index] = builder.setOptions(
            this.bedOptionValues
          );
        });
      }

      updatePrice(data) {
        const pdpPriceWrapper = this.pdpPrice.querySelector("div[data-price]");
        let price = pdpPriceWrapper.dataset.price * 1 || 0;
        let isAvailable = true;
        let incoming = [];

        if (this.baseVariant.id) {
          isAvailable = this.baseVariant.available;
          if (this.baseVariant.incoming && this.baseVariant.expected) {
            incoming.push(new Date(this.baseVariant.expected));
          }
        }
        Object.keys(this.sections).forEach((section) => {
          this.sections[section].forEach((item) => {
            if (item.id == this.baseVariant.id) {
              return;
            }
            price += item.price || 0;
            if (!item.available) {
              isAvailable = false;
            }
            if (item.incoming && item.expected) {
              incoming.push(new Date(item.expected));
            }
          });
        });
        this.pdpPrice.querySelector(".price-item--regular").innerText =
          this.formatMoney(price);


          // see if haulaway is checked
          let haulawayChecked = document.querySelector('input[name="bed[haulaway]"]:checked');
          let haulawayPrice = 0;
          // if haulaway is checked
          if (haulawayChecked) {
            // get haulaway price from checked bed[haulaway] data-price
            haulawayPrice = document.querySelector('input[name="bed[haulaway]"]:checked').dataset.price ?? 0;
          } else {
            haulawayPrice = 0;
          }

          const finalPrice = +price - +haulawayPrice;

          // set price for mattress
          document.querySelectorAll('.mattress .option-price__price').forEach((el) => {
            el.innerText = this.formatMoney(finalPrice);
          });

          // set price for base only
          document.querySelectorAll('.base .option-price__price').forEach((el) => {
            const currentBase = this.baseVariant.id;
            const basePrice = meta.product.variants.find(variant => variant.id === currentBase).price;
            console.log(basePrice);
            el.innerText = this.formatMoney(basePrice);
          });

        // if (data && data[0].discount) {
        //   this.discount = data[0].discount;
        // } else if(data) {
        //   this.discount = 0;
        // }
        // if(this.discount > 0) {
        //   document.querySelector(".price__savings").innerText =
        //     "Was " + this.formatMoney(price + this.discount);
        //   document.querySelector(".price__savings-bundle").innerText =
        //     this.formatMoney(this.discount) + " bundle savings";
        // } else {
        //   document.querySelector(".price__savings").innerText = "";
        //   document.querySelector(".price__savings-bundle").innerText = "";
        // }

        this.variantSelects[0].toggleAddButton(
          !isAvailable,
          window.variantStrings.soldOut
        );
        if (!isAvailable) {
          pdpPriceWrapper.classList.add("price--sold-out");
          pdpPriceWrapper.classList.add("price--show-badge");
        } else {
          pdpPriceWrapper.classList.remove("price--sold-out");
          pdpPriceWrapper.classList.remove("price--show-badge");
        }
        if (incoming.length) {
          let dateLength = incoming.length;
          if (dateLength > 1) {
            incoming.sort((a, b) => b - a);
          }
          let { 0: startDate, [dateLength - 1]: endDate } = incoming;
          let incomingString = startDate.toLocaleDateString(false, {
            month: "short",
            day: "numeric",
            year: "numeric",
          });
          if (dateLength > 1 && startDate < endDate) {
            let endDateString = endDate.toLocaleDateString(false, {
              month: "short",
              day: "numeric",
              year: "numeric",
            });
            incomingString += ` - ${endDateString}`;
          }
          incoming = incomingString;
          this.pdpForm.handleErrorMessage(
            `${this.bedData.strings.expected} ${incomingString}`
          );
        } else {
          this.pdpForm.handleErrorMessage();
        }
      }

      launchConfirm(target) {
        this.isAddingToCart = true;
        this.builderOptions.forEach((opt) => {
          const modal = opt.querySelector("option-select-modal");
          const prev = opt.previousSibling || false;
          modal.setAttribute("state", "next");
          modal.setAttribute("back", prev !== false);
        });
        this.builderOptions[0].openModal(target);
      }

      abortAddToCart() {
        console.info(`Aborting add to cart.`, this);
        this.builderOptions.forEach((opt) => {
          const modal = opt.querySelector("option-select-modal");
          modal.setAttribute("state", "close");
          modal.setAttribute("back", false);
        });
        this.pdpForm.resetState();
        this.isAddingToCart = false;
      }

      addToCart(shouldContinue) {
        let items = [];

        Object.keys(this.sections).forEach((section) => {
          this.sections[section].forEach((item) => {
            if (item.id == this.baseVariant.id) return;
            items.push({
              id: item.id,
              quantity: 1,
            });
          });
        });

        if (items.length) {
          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          config.body = JSON.stringify({
            items: items,
          });

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                console.error(response.description);
                return;
              }
              if (shouldContinue) {
                this.pdpForm.querySelector("form").dispatchEvent(
                  new CustomEvent("submit", {
                    cancelable: true,
                    detail: { continue: true },
                  })
                );
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.isAddingToCart = false;
            });
        }
      }

      getOptionData() {
        let data = this.querySelectorAll(
          ':scope > script[type="application/json"]'
        );
        if (data != null && data.length > 0) {
          data.forEach((item) => {
            let type = item.getAttribute("data-type") || false;
            if (type) {
              try {
                this.bedData[type] = JSON.parse(item.textContent || "{}");
              } catch (error) {
                console.error(`Unable to parse JSON ${type}:`, error, item);
              }
            }
          }, this);
        }
      }

      formatMoney(cents) {
        if (cents && !isNaN(cents)) {
          let amount = (cents / 100.0).toFixed(2);
          let parts = amount.split(".");
          amount =
            parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + ",") +
            (parts[1] ? "." + parts[1] : "");

          return this.dataset.moneyFormat.replace("0.00", amount);
        }
        return false;
      }
    }
  );
}
